export default (scopes, sId, checked) => {
	return [
		...scopes.map((scope) => {
			let s = {...scope};
			if (scope.id === sId) {
				s.selected = checked;
				s.teamList = [
					...s.teamList.map((team) => {
						let t = {...team};
						if (!t.disabled) t.selected = checked;
						return t;
					})
				];
			}

			return {
				...s
			};
		})
	];
};
